<template lang="pug">
  .sidebar(:class="{ open: openSidebar }")
    .search
      .search-menu
        .search-title
          span 絞り込む
        .search-row
          span.search-label
            | 事業所名
          label.text
            input(
              type="text"
              v-model="companyName"
              placeholder="例）株式会社XXXX"
              @keydown="keydownCondition"
              @keyup="keyupCondition")
        .search-row
          span.search-label
            | 更新日
          select(v-model="updatedDate")
            option(v-for="option in updatedDates" :value="option.code") {{ option.name }}
        .search-row
          span.search-label
            | 出稿メディア履歴
          select(v-model="publishedRecruitMediaTerm")
            option(v-for="option in publishedRecruitMediaTerms" :value="option.code")
              | {{ option.name }}
          MultipleSelect(v-model="publishedRecruitMediaCd" :options="vSelectMedia")
        .search-row
          span.search-label
            | 出稿予算
          select(v-model="budgetTerm")
            option(v-for="option in budgetTerms" :value="option.code") {{ option.name }}
          label
            select.select-short(v-model="budgetLower")
              option(v-for="option in budgetValues" :value="option.code")
                | {{ option.name }}
            span 〜
          label
            select.select-short(v-model="budgetUpper")
              option(v-for="option in budgetValues" :value="option.code")
                | {{ option.name }}
        .search-row
          span.search-label
            | 掲載状況
          label.radio
            input(type='radio' v-model="published" value="1")
            span 出稿履歴あり
          label.radio
            input(type='radio' v-model="published" value="2")
            span 直近1年間出稿履歴無し
          br
          label.radio
            input(type='radio' v-model="publishedRecruitOrAp" value="0")
            span すべて
          label.radio
            input(type='radio' v-model="publishedRecruitOrAp" value="1")
            span 中途のみ
          label.radio
            input(type='radio' v-model="publishedRecruitOrAp" value="2")
            span APのみ
          select(v-model="publishedTerm")
            option(v-for="option in publishedTerms" :value="option.code")
              | {{ option.name }}
        .search-row
          span.search-label 本社・所在地
          .select-tree(:class="{ active: openPrefectureCityModal }")
            a.select-tree-button(
              @click="toggleCompanyCityModal"
              :class="{ active: openPrefectureCityModal }")
              | 選択する
            span.select-tree-selected(v-if="cityCd.length > 0") 選択中
            PrefectureCityModal(
              :prefectures="this.$store.state.master.prefectures.filter(v=> v.code !== 99)"
              :openPrefectureCityModal="openPrefectureCityModal"
              :selectedCityCd="cityCd"
              @setPrefectureCities="setCityCd"
              @hide="hidePrefectureCityModal")
        .search-row
          span.search-label
            | 事業所の最寄駅
          .search-keyword-suggest(:class="{ active: showSearchStations }")
            label.text
              input(
                type="text",
                v-model="stationName",
                placeholder="",
                @keydown="keydownCondition"
                @keyup="keyupStation")
            ul(v-if="showSearchStations")
              li(v-for="option in filteredStations")
                a(@click="selectStation(option)") {{ option.name }}
        .search-row
          span.search-label
            | 業種
          MultipleSelect(v-model="industryCd" :options="vSelectIndustry")
        .search-row
          span.search-label
            | 設立
          select(v-model="establishedYear")
            option(v-for="option in establishedYears" :value="option.code") {{ option.name }}
        .search-row
          span.search-label
            | 特徴
          label.checkbox
            input(type='checkbox' v-model="prPointCd" id="prPointCd60" value="60")
            span 人材紹介・エージェントを省く
          label.checkbox
            input(type='checkbox' v-model="prPointCd" id="prPointCd62" value="62")
            span 派遣会社を省く
          label.checkbox
            input(type='checkbox' v-model="prPointCd" id="prPointCd61" value="61")
            span RPOを省く
          label.checkbox
            input(type="checkbox"
              v-model="excludedNoCompanyTel"
              true-value="true"
              false-value="false")
            span 電話番号なしを省く
          label.checkbox
            input(type="checkbox"
              v-model="excludedNoCompanyUrl"
              true-value="true"
              false-value="false")
            span 企業URLなしを省く
          label.checkbox
            input(type='checkbox' v-model="prPointCd" id="prPointCd40" value="40")
            span 上場企業・株式公開企業
          label.checkbox
            input(type='checkbox' v-model="prPointCd" id="prPointCd41" value="41")
            span 高成長企業
          label.checkbox
            input(type='checkbox' v-model="prPointCd" id="prPointCd42" value="42")
            span 外資系企業
        .search-row
          span.search-label
            | 事業所キーワード（事業内容など）
          label.text
            input(
              type="text"
              v-model="companyKeyword"
              placeholder="例）事業内容など"
              @keydown="keydownCondition"
              @keyup="keyupCondition")
        .search-row
          span.search-label
            | 事業所除外キーワード（事業内容など）
          label.text
            input(
              type="text"
              v-model="companyExcludeKeyword"
              placeholder="例）除外したい事業内容など"
              @keydown="keydownCondition"
              @keyup="keyupCondition")
        .search-row(v-if="keyword.length || excludeKeyword.length")
          span.search-label
            | 求人掲載状況
          select(v-model="viewEndDate")
            option(v-for="option in postingSituations" :value="option.code") {{ option.name }}
        .search-row
          span.search-label 求人キーワード（{{ this.maxKeywords }}個まで）
          span.keyword-info 改行でキーワードを追加
          .keyword-tag-area
            .select-choice(:class="keyword.length > 0 ? 'open' : ''")
              ul.select-choice-selected
                li(v-for="(tag, index) in this.keyword")
                  div {{ tag }}
                  a.select-choice-delete(@click="removeKeyword(index)")
          label.text
            input(
              type="text"
              placeholder="例）仕事内容、資格など"
              @keydown="keydownCondition"
              @keyup="keywordEnter($event)")
          span.search-label-sub 適用項目
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyKeywordsToCatchcopy"
              true-value="true"
              false-value="false")
            span キャッチコピー
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyKeywordsToJobtypeName"
              true-value="true"
              false-value="false")
            span 募集職種
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyKeywordsToJobContents"
              true-value="true"
              false-value="false")
            span 仕事内容
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyKeywordsToQualification"
              true-value="true"
              false-value="false")
            span 応募資格
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyKeywordsToCompanyName"
              true-value="true"
              false-value="false")
            span 事業所名
        .search-row
          span.search-label 求人除外キーワード({{ this.maxKeywords }}個まで)
          span.keyword-info 改行でキーワードを追加
          .keyword-tag-area
            .select-choice(:class="excludeKeyword.length > 0 ? 'open' : ''")
              ul.select-choice-selected
                li(v-for="(tag, index) in this.excludeKeyword")
                  div {{ tag }}
                  a.select-choice-delete(@click="removeExcludeKeyword(index)")
          label.text
            input(
              type="text"
              placeholder="例）除外したい仕事内容、資格など"
              @keydown="keydownCondition"
              @keyup.enter="excludeKeywordEnter($event)")
          .keyword
            a.keyword-button(@click="applyRecommendedExcludeKeywords")
              | おすすめキーワードを設定する
          span.search-label-sub 適用項目
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyExcludeKeywordsToCatchcopy"
              true-value="true"
              false-value="false")
            span キャッチコピー
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyExcludeKeywordsToJobtypeName"
              true-value="true"
              false-value="false")
            span 募集職種
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyExcludeKeywordsToJobContents"
              true-value="true"
              false-value="false")
            span 仕事内容
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyExcludeKeywordsToQualification"
              true-value="true"
              false-value="false")
            span 応募資格
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyExcludeKeywordsToCompanyName"
              true-value="true"
              false-value="false")
            span 事業所名
      .search-button
        input.button-main(
          type="button"
          @click="search"
          value="検索する"
          :disabled="locked")
        span
          a(@click="clear") クリア
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  import {
    updatedDates,
    establishedYears,
    publishedRecruitMediaTerms,
    publishedTerms,
    postingSituations,
    DefaultViewEndCode,
    budgetTerms,
    budgetValues,
    DefaultUpdatedDateCode,
    DefaultBudgetTerm,
    DefaultEstablishedYear,
    DefaultPublished,
    DefaultPublishedRecruitMediaTerm,
    DefaultPublishedRecruitOrAp,
    DefaultPublishedTerm,
    DefaultSearchCompanyQuery,
    DefaultExcludedNoCompanyTel,
    DefaultExcludedNoCompanyUrl,
    DefaultApplyKeywordsToCatchcopy,
    DefaultApplyKeywordsToJobtypeName,
    DefaultApplyKeywordsToJobContents,
    DefaultApplyKeywordsToQualification,
    DefaultApplyKeywordsToCompanyName,
    DefaultApplyExcludeKeywordsToCatchcopy,
    DefaultApplyExcludeKeywordsToJobtypeName,
    DefaultApplyExcludeKeywordsToJobContents,
    DefaultApplyExcludeKeywordsToQualification,
    DefaultApplyExcludeKeywordsToCompanyName,
    maxKeywords,
    recommendedExcludeKeywords,
  } from '../../constants'
  import { api } from '../../libs/api'
  import mapGetSet from '../../libs/map-get-set'
  import searchCompany from '../../store/modules/searchCompany'
  import MultipleSelect from '../parts/MultipleSelect'
  import PrefectureCityModal from '../parts/PrefectureCityModal'

  export default {
    components: { MultipleSelect, PrefectureCityModal },
    props: ['openSidebar'],
    beforeCreate () {
      this.updatedDates = updatedDates
      this.establishedYears = establishedYears
      this.publishedRecruitMediaTerms = publishedRecruitMediaTerms
      this.publishedTerms = publishedTerms
      this.postingSituations = postingSituations
      this.budgetTerms = budgetTerms
      this.budgetValues = budgetValues
      this.maxKeywords = maxKeywords
    },
    data () {
      const {
        updatedDate = DefaultUpdatedDateCode,
        budgetLower = '',
        budgetUpper = '',
        budgetTerm = DefaultBudgetTerm,
        companyName = '',
        cityCd = '',
        establishedYear = DefaultEstablishedYear,
        industryCd = '',
        companyKeyword = '',
        companyExcludeKeyword = '',
        keyword = '',
        excludeKeyword = '',
        prPointCd = '',
        published = DefaultPublished,
        publishedRecruitMediaCd = '',
        publishedRecruitMediaTerm = DefaultPublishedRecruitMediaTerm,
        publishedTerm = DefaultPublishedTerm,
        publishedRecruitOrAp = DefaultPublishedRecruitOrAp,
        stationId = '',
        viewEndDate = DefaultViewEndCode,
        excludedNoCompanyTel = DefaultExcludedNoCompanyTel,
        excludedNoCompanyUrl = DefaultExcludedNoCompanyUrl,
        applyKeywordsToCatchcopy = DefaultApplyKeywordsToCatchcopy,
        applyKeywordsToJobtypeName = DefaultApplyKeywordsToJobtypeName,
        applyKeywordsToJobContents = DefaultApplyKeywordsToJobContents,
        applyKeywordsToQualification = DefaultApplyKeywordsToQualification,
        applyKeywordsToCompanyName = DefaultApplyKeywordsToCompanyName,
        applyExcludeKeywordsToCatchcopy = DefaultApplyExcludeKeywordsToCatchcopy,
        applyExcludeKeywordsToJobtypeName = DefaultApplyExcludeKeywordsToJobtypeName,
        applyExcludeKeywordsToJobContents = DefaultApplyExcludeKeywordsToJobContents,
        applyExcludeKeywordsToQualification = DefaultApplyExcludeKeywordsToQualification,
        applyExcludeKeywordsToCompanyName = DefaultApplyExcludeKeywordsToCompanyName,
      } = this.$route.query

      // query parameter initialization
      const master = this.$store.state.master
      this.updatedDate = updatedDate
      this.budgetLower = budgetLower
      this.budgetUpper = budgetUpper
      this.budgetTerm = budgetTerm
      this.companyName = companyName
      this.cityCd = this.toObjects(cityCd, master.cities)
      this.establishedYear = establishedYear
      this.industryCd = this.toObjects(industryCd, master.industries)
      this.companyKeyword = companyKeyword
      this.companyExcludeKeyword = companyExcludeKeyword
      this.keyword = this.toKeywordObjects(keyword)
      this.excludeKeyword = this.toKeywordObjects(excludeKeyword)
      this.prPointCd = this.toArray(prPointCd)
      this.published = published
      this.publishedRecruitMediaCd = this.toObjects(publishedRecruitMediaCd, master.mediaForJobs)
      this.publishedRecruitMediaTerm = publishedRecruitMediaTerm
      this.publishedTerm = publishedTerm
      this.publishedRecruitOrAp = publishedRecruitOrAp
      this.stationId = stationId
      this.viewEndDate = viewEndDate
      this.excludedNoCompanyTel = excludedNoCompanyTel
      this.excludedNoCompanyUrl = excludedNoCompanyUrl
      this.applyKeywordsToCatchcopy = applyKeywordsToCatchcopy
      this.applyKeywordsToJobtypeName = applyKeywordsToJobtypeName
      this.applyKeywordsToJobContents = applyKeywordsToJobContents
      this.applyKeywordsToQualification = applyKeywordsToQualification
      this.applyKeywordsToCompanyName = applyKeywordsToCompanyName
      this.applyExcludeKeywordsToCatchcopy = applyExcludeKeywordsToCatchcopy
      this.applyExcludeKeywordsToJobtypeName = applyExcludeKeywordsToJobtypeName
      this.applyExcludeKeywordsToJobContents = applyExcludeKeywordsToJobContents
      this.applyExcludeKeywordsToQualification = applyExcludeKeywordsToQualification
      this.applyExcludeKeywordsToCompanyName = applyExcludeKeywordsToCompanyName

      if (this.$route.query.stationId) {
        api.fetchStation({ id: this.$route.query.stationId })
          .then((res) => {
            if (res) {
              this.stationName = res[0].name
            }
          })
      } else {
        this.stationName = ''
      }

      return {
        filteredStations: [],
        timeoutId: null,
        keyDownCode: '',
        openPrefectureCityModal: false,
      }
    },
    computed: {
      ...mapGetters({
        apiQuery: 'searchCompany/apiQuery',
        locked: 'common/isGlobalLocked',
      }),
      vSelectIndustry () {
        // 事業所検索には「製造業」を表示しない
        return this.$store.state.master.industries.map(i => ({ label: i.name, value: i.code }))
      },
      vSelectMedia () {
        return this.$store.state.master.mediaForJobs.map(m => ({ label: m.name, value: m.code }))
      },
      ...mapGetSet({
        _this: this,
        get: ($vm, $s, k) => $s.state.searchCompany.query[k],
        set: ($vm, $s, k, v) => $s.commit(`searchCompany/${k}`, v),
        keys: Object.keys(searchCompany.state.query),
      }),
      showSearchStations () {
        return this.filteredStations.length > 0
      },
    },
    watch: {
      $route () {
        Object.assign(this.$data, this.$options.data.apply(this))
      },
    },
    methods: {
      ...mapMutations('company', ['uncheckAll']),
      clear () {
        const { name } = this.$route
        this.uncheckAll()
        this.$emit('toggleSidebar')
        const query = {
          ...DefaultSearchCompanyQuery,
          perPage: String(this.$store.state.user.detail.companies_per_page),
          page: '1',
          _t: new Date().getTime(),
        }
        this.$router.push({ name, query })
      },
      hidePrefectureCityModal () {
        this.openPrefectureCityModal = false
      },
      async keydownCondition (e) {
        this.keyDownCode = e.which
      },
      async keyupCondition (e) {
        // Enter押下時に検索する。keyDownCode持ってるのは日本語変換のEnterを無視するため
        if (e.which === 13 && e.which === this.keyDownCode) {
          this.search()
        }
      },
      async keyupStation () {
        clearTimeout(this.timeoutId)
        this.timeoutId = setTimeout(() => {
          if (this.stationName) {
            api.fetchStations({ stationName: this.stationName })
              .then((res) => {
                this.filteredStations = res
              })
          } else {
            this.stationId = ''
            this.filteredStations = []
          }
        }, 500)
      },
      async search () {
        const { name, query } = this.$route
        this.$store.commit('common/lockGlobal')
        this.uncheckAll()
        try {
          this.$router.push({
            name,
            query: {
              ...this.apiQuery,
              perPage: query.perPage,
              page: '1',
              _t: Date.now(),
            },
          })
        } finally {
          this.$emit('toggleSidebar')
          this.$store.commit('common/unlockGlobal')
        }
      },
      selectStation (station) {
        this.stationId = station.id
        this.stationName = station.name
        this.filteredStations = []
      },
      async setCityCd (cityCd) {
        this.openPrefectureCityModal = false
        this.cityCd = cityCd
      },
      toArray (ids) {
        if (!ids) {
          return []
        }
        return ids.split(',')
      },
      toObjects (ids, masterData) {
        if (!ids) {
          return []
        }

        const isNumber = typeof masterData[0].code === 'number'
        return ids.split(',').map((id) => {
          const data = isNumber ?
            masterData.find(d => d.code === Number(id)) :
            masterData.find(d => d.code === id)
          return { label: data.name, value: data.code }
        })
      },
      toKeywordObjects (words) {
        if (!words) {
          return []
        }
        return words.split(',')
      },
      keywordEnter (e) {
        if (e.which === 13 && e.which === this.keyDownCode) {
          if (typeof e.target.value === 'string' && e.target.value.trim() !== '') {
            this.addKeyword(e.target.value.trim())
            e.target.value = ''
          }
        }
      },
      excludeKeywordEnter (e) {
        if (e.which === 13 && e.which === this.keyDownCode) {
          if (typeof e.target.value === 'string' && e.target.value.trim() !== '') {
            this.addExcludeKeyword(e.target.value.trim())
            e.target.value = ''
          }
        }
      },
      addKeyword (str) {
        if (this.keyword.length === this.maxKeywords) {
          // eslint-disable-next-line no-alert
          return alert(`キーワードは${this.maxKeywords}個までです。`)
        }
        this.$store.commit('searchCompany/addKeyword', str)
      },
      addExcludeKeyword (str) {
        if (this.excludeKeyword.length === this.maxKeywords) {
          // eslint-disable-next-line no-alert
          return alert(`除外キーワードは${this.maxKeywords}個までです。`)
        }
        this.$store.commit('searchCompany/addExcludeKeyword', str)
      },
      applyRecommendedExcludeKeywords (e) {
        e.stopPropagation()
        this.excludeKeyword = this.toKeywordObjects(recommendedExcludeKeywords)
      },
      removeKeyword (index) {
        this.$store.commit('searchCompany/removeKeyword', index)
      },
      removeExcludeKeyword (index) {
        this.$store.commit('searchCompany/removeExcludeKeyword', index)
      },
      toggleCompanyCityModal (e) {
        e.stopPropagation()
        this.openPrefectureCityModal = !this.openPrefectureCityModal
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/CompanySidebar.vue